import { orchestrator } from "satcheljs";
import { onCopilotChatDrawerAutoOpenPrerequisiteChanged } from "owa-copilot-chat-drawer-store";
import { handleCopilotChatAutoOpen } from "../utils/handleCopilotChatAutoOpen";
import { getPendingAutoOpenOperation } from "../utils/tryAutoOpen";
import tryRunPendingAutoOpenOperation from "../utils/tryRunPendingAutoOpenOperation";

orchestrator(onCopilotChatDrawerAutoOpenPrerequisiteChanged, ({ targetWindow }) => {
    if (targetWindow === window && getPendingAutoOpenOperation() === handleCopilotChatAutoOpen) {
        tryRunPendingAutoOpenOperation();
    }
});
